import { useTranslation } from "react-i18next";
import { Button } from "antd";
import {
  FaHome,
  FaBuilding,
  FaCreditCard,
  FaFileAlt,
  FaThLarge,
  FaPercent,
  FaBook,
} from "react-icons/fa";

interface WelcomeProps {
  nextButton: () => void;
}

const stepOverview = [
  { icon: <FaBuilding />, label: "Company" },
  { icon: <FaCreditCard />, label: "Payments" },
  { icon: <FaFileAlt />, label: "Formats" },
  { icon: <FaThLarge />, label: "Features" },
  { icon: <FaPercent />, label: "Vats" },
  { icon: <FaBook />, label: "Accounting" },
];

export default function Welcome(props: WelcomeProps) {
  const { nextButton } = props;
  const { t } = useTranslation();
  return (
    <div className="welcome-hero">
      <div className="welcome-hero-accent">
        <div className="welcome-hero-icon">
          <FaHome />
        </div>
      </div>
      <div className="welcome-hero-content">
        <h1 className="welcome-hero-heading">{t("Welcome to NeoFact")}</h1>
        <p className="welcome-hero-subtitle">
          {t(
            "Let's set up your workspace in just a few steps. We'll personalize NeoFact to fit your business needs.",
          )}
        </p>
        <div className="welcome-steps-overview">
          <h3 className="welcome-steps-overview-title">{t("What we'll set up")}</h3>
          <div className="welcome-steps-list">
            {stepOverview.map((step, index) => (
              <div key={index} className="welcome-step-item">
                <span className="welcome-step-number">{index + 1}</span>
                <span className="welcome-step-icon">{step.icon}</span>
                <span className="welcome-step-label">{t(step.label)}</span>
              </div>
            ))}
          </div>
        </div>
        <Button
          type="primary"
          size="large"
          className="welcome-cta-btn"
          onClick={() => nextButton()}
        >
          {t("Get Started")}
        </Button>
      </div>
    </div>
  );
}
